import { FiSend } from "react-icons/fi";
import { GrMicrophone } from "react-icons/gr";
import { MdAttachFile } from "react-icons/md";
import { Link, useNavigate } from 'react-router-dom';
import SubNav from '../components/subNav';
import SEO from '../components/SEO';
import { renderBudgetBreakdown } from '../pages/marketAnalysis';
import React, { useState } from 'react';
import { RiArrowDropDownLine, RiArrowDropUpLine } from "react-icons/ri";
import itunes from '../assets/img/itunes.png';
import netflix from '../assets/img/netflix.png';
import prime from '../assets/img/prime.png';
import { baseUrl } from '../config';



const Distributions = () => {
  // State to manage which dropdown is open
  let navigate=useNavigate();
  const [openDropdown, setOpenDropdown] = useState(null);

  // Function to toggle dropdown
  const toggleDropdown = (dropdown) => {
    if (openDropdown === dropdown) {
      setOpenDropdown(null); // Close the dropdown if it's already open
    } else {
      setOpenDropdown(dropdown); // Open the clicked dropdown
    }
  };
  function handleNetflix(){
    navigate('/netflix')
  }
  function handlePrime(){
    navigate('/prime')
  }
  function handleItunes(){
    navigate('/itunes')
  }
  return (
    <>
    <div className='bg-gray-900 text-white min-h-screen p-4'>
      <div className="max-w-7xl mx-auto">
        <h2 className='font-extrabold text-center p-4 text-yellow-400' style={{fontSize:'32px'}} >
          Connect with Distributors Who Value Your Movie
        </h2>
        <p className='text-center text-lg p-4 max-w-3xl mx-auto text-gray-300'>
          Explore various distribution channels and connect with the right distributors for your movie. Whether it's digital, theatrical, or TV broadcast, we have options for you.
        </p>

        {/* First Row of Distribution Categories */}
        <div className='flex flex-col lg:flex-row justify-center items-center gap-8 py-8'>
          <div className='bg-gray-800 shadow-lg p-5 rounded-lg w-full lg:w-1/3 cursor-pointer' onClick={() => toggleDropdown('digital')}>
            <div className='flex justify-between items-center'>
              <p className='text-xl'>Digital Distributions</p>
              {openDropdown === 'digital' ? <RiArrowDropUpLine size={30} /> : <RiArrowDropDownLine size={30} />}
            </div>
            {openDropdown === 'digital' && (
              <div className="p-4 text-gray-300">
                <p>Digital distribution offers opportunities to showcase your movie on platforms like Netflix, Amazon Prime, or iTunes.</p>
                <div className='flex p-2 pt-5 w-100% gap-10'>
                  <img src={netflix} alt='netflix' className='w-30 h-25 mx-4' onClick={handleNetflix}/>
                  <img src={prime} alt='netflix' className='w-35 h-25 mx-5' onClick={handlePrime}/>
                  <img src={itunes} alt='itunes' className='w-30 h-25' onClick={handleItunes}/>
                </div>
              </div>
            )}
          </div>

          <div className='bg-gray-800 shadow-lg p-5 rounded-lg w-full lg:w-1/3 cursor-pointer' onClick={() => toggleDropdown('theatrical')}>
            <div className='flex justify-between items-center'>
              <p className='text-xl'>Theatrical Distributions</p>
              {openDropdown === 'theatrical' ? <RiArrowDropUpLine size={30} /> : <RiArrowDropDownLine size={30} />}
            </div>
            {openDropdown === 'theatrical' && (
              <div className="p-4 text-gray-300">
                <p>Get your movie on the big screen. We connect you with distributors who specialize in theatrical releases worldwide.</p>
              </div>
            )}
          </div>
        </div>

        {/* Second Row of Distribution Categories */}
        <div className='flex flex-col lg:flex-row justify-center items-center gap-8 py-4'>
          <div className='bg-gray-800 shadow-lg p-5 rounded-lg w-full lg:w-1/3 cursor-pointer' onClick={() => toggleDropdown('vod')}>
            <div className='flex justify-between items-center'>
              <p className='text-xl'>Video On Demand</p>
              {openDropdown === 'vod' ? <RiArrowDropUpLine size={30} /> : <RiArrowDropDownLine size={30} />}
            </div>
            {openDropdown === 'vod' && (
              <div className="p-4 text-gray-300">
                <p>Distribute your movie through video-on-demand (VOD) platforms like YouTube, Vimeo, and others.</p>
              </div>
            )}
          </div>

          <div className='bg-gray-800 shadow-lg p-5 rounded-lg w-full lg:w-1/3 cursor-pointer' onClick={() => toggleDropdown('screening')}>
            <div className='flex justify-between items-center'>
              <p className='text-xl'>Distributor Screening</p>
              {openDropdown === 'screening' ? <RiArrowDropUpLine size={30} /> : <RiArrowDropDownLine size={30} />}
            </div>
            {openDropdown === 'screening' && (
              <div className="p-4 text-gray-300">
                <p>Arrange private screenings with potential distributors to showcase your movie in a professional setting.</p>
              </div>
            )}
          </div>

          <div className='bg-gray-800 shadow-lg p-5 rounded-lg w-full lg:w-1/3 cursor-pointer' onClick={() => toggleDropdown('broadcast')}>
            <div className='flex justify-between items-center'>
              <p className='text-xl'>TV Broadcast</p>
              {openDropdown === 'broadcast' ? <RiArrowDropUpLine size={30} /> : <RiArrowDropDownLine size={30} />}
            </div>
            {openDropdown === 'broadcast' && (
              <div className="p-4 text-gray-300">
                <p>Get your movie on TV channels across the globe, reaching millions of viewers through licensed TV broadcasting.</p>
              </div>
            )}
          </div>
        </div>

        {/* Call to Action */}
        <div className='text-center py-10'>
          <Link to='/connect' className='bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-semibold px-6 py-3 rounded-lg shadow-lg'>
            Get Connected with Distributors
          </Link>
        </div>
      </div>
    </div>
    </>
  );
}

const PostDashboard = () => {
  const navigate=useNavigate();
  function handleAnalysis(){
    navigate('/post-analysis')
  }
  function handleDistributions(){
    navigate('/distributions')
  }
  return (
    <div className="p-3  w-screen bg-white">
      <SEO
        title="Post-Production Dashboard"
        description="Manage your film's post-production workflow — editing, sound, VFX, and delivery — with ProducerBuddy's post-production dashboard."
        url="https://producerbuddy.pilomation.com/post-dashboard"
        robots="noindex, nofollow"
      />
      <SubNav/>
      <div className="flex flex-col flex-grow overflow-y-auto">
        {/* Header Section */}
        <div className="flex justify-center items-center px-10 py-6">
          <h1 className="text-2xl font-bold text-center">Dashboard</h1>
        </div>

        <form>   
        <div className="relative flex justify-center items-center p-4 bg-gray-10">
            <input 
                type="search" 
                id="search" 
                className="block w-50 p-3 pl-12 pr-24 text-sm text-gray-900 border border-gray-50 rounded-lg focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                placeholder="Search" 
                required 
            />
            <div className="relative inset-y-0 right-5 flex items-center pr-3 space-x-2">
                <Link to='/market-analysis'><MdAttachFile className="text-xl text-gray-500 dark:text-gray-400" /></Link>
                <GrMicrophone className="text-xl text-gray-500 dark:text-gray-400" />
                <FiSend className="text-xl text-gray-500 dark:text-blue-400" />
            </div>
        </div>
    </form>

        <div className="flex flex-col gap-8 p-6 ">
          <div className="w-100 h-100 bg-white rounded-lg shadow-md p-6  mx-5" onClick={handleAnalysis}>
            <p className='font-bold text-left'>Analysis board</p>
            {renderBudgetBreakdown()}
          </div>
          <div className='w-100 h-100 bg-white rounded-lg shadow-md p-6  mx-5' onClick={handleDistributions}>
              <Distributions/>
            </div>
          <div className="w-100 h-100 bg-white rounded-lg shadow-md p-6">
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostDashboard;

